/* eslint-disable unicorn/prevent-abbreviations, unicorn/consistent-function-scoping */
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { getShortMonthString } from '../../../../helpers/booking';
import ThemeContext from '../../../../providers/ThemeProvider';

const BookingCalendarNav = ({
  disabledNext,
  disabledPrev,
  isCheckinNearMonthEnd,
  month,
  next,
  onNext,
  onPrev,
  prev,
  year,
}) => {
  const theme = useContext(ThemeContext);
  const threeSpaces = () => {
    return <>&nbsp;&nbsp;&nbsp;</>;
  };
  const [nextMonthDisplay, setNextMonthDisplay] = useState(threeSpaces());
  const [prevMonthDisplay, setPrevMonthDisplay] = useState(threeSpaces());

  useEffect(() => {
    if (next) {
      setNextMonthDisplay(getShortMonthString(next.month));
    } else {
      setNextMonthDisplay(threeSpaces());
    }
    if (prev) {
      setPrevMonthDisplay(getShortMonthString(prev.month));
    } else {
      setPrevMonthDisplay(threeSpaces());
    }
  }, [next, prev]);

  return (
    <>
      <div className="booking-calendar__nav">
        <div className="booking-calendar__head">
          <button
            className="booking-calendar__nav-button"
            disabled={disabledPrev}
            onClick={onPrev}
            type="button"
          >
            <FontAwesomeIcon icon={faChevronLeft} /> {prevMonthDisplay}
          </button>
          <p className="booking-calendar__month">
            {month} {year}
          </p>
          <button
            className="booking-calendar__nav-button"
            disabled={disabledNext}
            onClick={onNext}
            type="button"
          >
            <span
              className={classNames('booking-calendar-next', {
                'booking-calendar-next__highlight': isCheckinNearMonthEnd,
              })}
            >
              {nextMonthDisplay}
            </span>{' '}
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
        <div className="booking-calendar__days">
          <div className="booking-calendar__day">M</div>
          <div className="booking-calendar__day">T</div>
          <div className="booking-calendar__day">W</div>
          <div className="booking-calendar__day">Th</div>
          <div className="booking-calendar__day">F</div>
          <div className="booking-calendar__day">S</div>
          <div className="booking-calendar__day">S</div>
        </div>
      </div>
      <style jsx>{`
        .booking-calendar__nav {
          background-color: ${theme.colors.primary};
          color: ${theme.colors.textonprimary};
        }
        .booking-calendar__head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          min-height: 40px;
          padding: 0 10px;
        }
        .booking-calendar__nav-button {
          background: none;
          border: none;
          color: ${theme.colors.textonprimary};
          font-size: 16px;
          font-weight: bold;
        }
        .booking-calendar__nav-button:disabled {
          opacity: 0.4;
        }
        .booking-calendar__month {
          margin: 0;
          font-size: 16px;
          font-weight: bold;
        }
        .booking-calendar__days {
          display: flex;
          text-align: center;
          width: 100%;
        }
        .booking-calendar__day {
          flex-grow: 1;
          flex-basis: 0;
          padding: 0 10px 10px 10px;
        }
        .booking-calendar-next {
          font-size: 16px;
          font-weight: bold;
          transition: all 0.25s linear;
        }
        .booking-calendar-next__highlight {
          font-size: 21px;
          font-weight: bold;
          transition: all 0.25s linear;
        }
      `}</style>
    </>
  );
};

BookingCalendarNav.propTypes = {
  disabledNext: PropTypes.bool,
  disabledPrev: PropTypes.bool,
  isCheckinNearMonthEnd: PropTypes.bool,
  month: PropTypes.string,
  next: PropTypes.object,
  onNext: PropTypes.func,
  onPrev: PropTypes.func,
  prev: PropTypes.object,
  year: PropTypes.number,
};

BookingCalendarNav.defaultProps = {
  disabledNext: true,
  disabledPrev: true,
  isCheckinNearMonthEnd: false,
  month: 'January',
  next: {},
  onNext: () => false,
  onPrev: () => false,
  prev: {},
  year: 2_021,
};

export default BookingCalendarNav;
